export default __webpack_public_path__ + "static/media/8.a45bfc4e.jpeg";